import { formatCurrency } from 'lib/format/formatCurrencyIntl'
import { RedeemedCard } from './common'
import config from 'constants/config'

const LE_CARD_NUMBER_LENGTH = 16
const BLACK_HAWK_SPEND_LIMIT_PER_ORDER = 1500

export const isBlackhwakCard = (code: string): boolean => {
  if (code.length === LE_CARD_NUMBER_LENGTH && code.match(/[0-9]{16}/)) {
    return true
  }
  return code.length > LE_CARD_NUMBER_LENGTH
}

export const validateGiftCard = (redeemedCards: Array<RedeemedCard>, redeemedCard: RedeemedCard, payable: number): void => {
  if (isDuplicateGiftCard(redeemedCards, redeemedCard)) {
    throw new Error('This gift card has already been redeemed.')
  }

  if (isBlackhawkLimitReached(redeemedCards, redeemedCard)) {
    const regionCode = config.regions.find(region => region.currencyCode === redeemedCard.currencyCode)?.code || 'AU'
    throw new Error(`Maximum redemption value of ${formatCurrency(BLACK_HAWK_SPEND_LIMIT_PER_ORDER, redeemedCard.currencyCode, regionCode)} for physical Gift Card reached`)
  }

  if (isRedeemedHigherThanPayable(redeemedCards, payable)) {
    throw new Error('Cannot redeem once gift card value is higher than payable amount.')
  }
}

const isDuplicateGiftCard = (redeemedCards: Array<RedeemedCard>, redeemedCard: RedeemedCard): boolean => {
  return redeemedCards.some(card => card.code === redeemedCard.code)
}

const isRedeemedHigherThanPayable = (redeemedCards: Array<RedeemedCard>, payable: number): boolean => {
  return redeemedCards.reduce((acc, card) => acc + card.amount, 0) >= payable
}

const isBlackhawkLimitReached = (redeemedCards: Array<RedeemedCard>, redeemedCard: RedeemedCard): boolean => {
  const redeemedCardAmount = isBlackhwakCard(redeemedCard.code) ? redeemedCard.amount : 0
  const pinCardsTotal = redeemedCards
    .filter(card => isBlackhwakCard(card.code))
    .reduce((acc, card) => acc + card.amount, 0)

  return pinCardsTotal + redeemedCardAmount > BLACK_HAWK_SPEND_LIMIT_PER_ORDER
}
